import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_AI_TWIN_DEMO_6 = {
  title: `After implementing the recommended \nenhancements to our campaign \nstrategies, <span style="color: #BEE3FF;">Maya is now empowered to \nwitness tangible improvements in key \nperformance indicators, including \ncustomer traffic, conversions, ROI</span> \nthereby solidifying her path to success.`,
  subtitle: "near Real-Time Nudges & Foresights",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage(311),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(309),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "AI_TWIN/AI_Twin_04.png",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "AI_TWIN/AI_TWIN_DEMO_computer.png",
          imageStyle: {
            position: "absolute",
            right: "63.62px",
            bottom: "272px",
          },
          effect: "animate-opacity",
        },
        {
          image: "AI_TWIN/AI_TWIN_DEMO_6_bubble_4.png",
          imageStyle: {
            position: "absolute",
            right: "351px",
            bottom: "771px",
          },
        },
        {
          image: "AI_TWIN/AI_TWIN_DEMO_6_bubble_2.png",
          imageStyle: { position: "absolute", right: "100px", bottom: "362px" },
          effect: "animate-opacity",
        },
        {
          image: "AI_TWIN/AI_TWIN_DEMO_6_bubble_3.png",
          imageStyle: {
            position: "absolute",
            right: "638.9px",
            bottom: "465.81px",
          },
          effect: "animate-opacity",
        },
        {
          image: "AI_TWIN/AI_TWIN_DEMO_6_bubble_1.png",
          imageStyle: {
            position: "absolute",
            right: "95.54px",
            bottom: "82px",
          },
        },
      ]}
      pageNumber={310}
    />
  ),
};
